module.exports = __webpack_public_path__ + "img/20190928142618360截图20190928132219794.dbaab754.jpg";